import { PayrollDetails } from './EmployeeExpense';
import Data from './Data/data.json'

export const data = Data;